'use client'

export default function HeaderIconsDefault() {
    return null
}
